import React from 'react'
import { cva } from 'class-variance-authority'
import { cn } from '../../lib/utils'

const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded text-sm font-normal ring-offset-background transition-opacity duration-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0052CC] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 disabled:text-[#9CA3AF] font-[system-ui]',
  {
    variants: {
      variant: {
        solid: 'bg-[#0052CC] text-white hover:bg-[#003d99] active:opacity-75',
        outline: 'border border-[#D1D5DB] bg-white text-[#1F2937] hover:bg-[#F5F5F5] active:opacity-75',
        ghost: 'text-[#1F2937] hover:bg-[#F5F5F5] active:opacity-75',
      },
      size: {
        default: 'h-8 px-4 py-2',
        sm: 'h-7 px-3 py-1',
        lg: 'h-10 px-6 py-3',
        icon: 'h-8 w-8',
      },
    },
    defaultVariants: {
      variant: 'solid',
      size: 'default',
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? 'span' : 'button'
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = 'Button'

export { Button, buttonVariants } 